import React from 'react';
import { SizableText, XStack, YStack } from 'tamagui';
import { BodyText } from '@/components/ui/Typography';

interface ShortcutsTabContentProps {
  isActive: boolean;
}

const SHORTCUTS = [
  { keys: ['Space', 'K'], label: 'Play / Pause', multi: true },
  { keys: ['J'], label: 'Skip backward 15 seconds' },
  { keys: ['L'], label: 'Skip forward 15 seconds' },
  { keys: ['←'], label: 'Skip backward 5 seconds' },
  { keys: ['→'], label: 'Skip forward 5 seconds' },
  { keys: ['F'], label: 'Toggle fullscreen' },
];

export function ShortcutsTabContent({ isActive }: ShortcutsTabContentProps) {
  return (
    <YStack
      gap="$4"
      w="100%"
      opacity={isActive ? 1 : 0}
      position={isActive ? 'relative' : 'absolute'}
      pointerEvents={isActive ? 'auto' : 'none'}
      style={{ left: 0, right: 0, top: 0, width: '100%', zIndex: isActive ? 1 : 0 }}
    >
      <BodyText
        color="#2B2B2B"
        letterSpacing={0.25}
      >
        Use these keyboard shortcuts to control the video player
      </BodyText>

      <YStack gap="$3">
        {SHORTCUTS.map(({ keys, label, multi }) => (
          <XStack key={label} ai="center" gap="$4" flexWrap="wrap">
            <XStack
              minWidth={120}
              p="$3"
              br="$3"
              bg="#F5F3EE"
              ai="center"
              jc="center"
              gap="$1"
              style={{ borderWidth: 1, borderColor: '#E0E0E0' }}
            >
              {keys.map((key, i) => (
                <React.Fragment key={key}>
                  <SizableText fontWeight="700" size="$4" $gtSm={{ size: '$5' }} color="#0D0D0D">
                    {key}
                  </SizableText>
                  {multi && i < keys.length - 1 && (
                    <SizableText fontWeight="600" size="$3" color="#5C5854">or</SizableText>
                  )}
                </React.Fragment>
              ))}
            </XStack>
            <BodyText
              color="#2B2B2B"
              letterSpacing={0.25}
              flex={1}
              minWidth={200}
            >
              {label}
            </BodyText>
          </XStack>
        ))}
      </YStack>
    </YStack>
  );
}
